import { FormBase } from 'core/components';

export default class FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'clinicalStatusNote',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.CLINICAL_STATUS_NOTE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.CLINICAL_STATUS_NOTE_PLACEHOLDER',
                    rules: 'string'            
                },
            ],
        };
    }
}
